import {ValueObject} from '@s-ui/domain'

import {SpecificationVehiclesValueObject} from './SpecificationVehiclesValueObject.js'

export class ModelsSpecificationListVehiclesValueObject extends ValueObject {
  #models

  constructor({models}) {
    super()
    this.#models = models
  }

  static empty() {
    return new ModelsSpecificationListVehiclesValueObject({models: []})
  }

  static createFromLiterals({models}) {
    if (!models.length) return ModelsSpecificationListVehiclesValueObject.empty()

    return new ModelsSpecificationListVehiclesValueObject({
      models: models.map(({icon, id, name}) => SpecificationVehiclesValueObject.createFromLiterals({icon, id, name}))
    })
  }

  isEmpty() {
    return !this.#models.length
  }

  get value() {
    return this.#models.map(model => model.value)
  }
}
